import React from "react";
// import "./ComplexSimplicity.css";
import Button from "../../_components/button/Button";
import SlideOver from "../../_components/slide_over/SlideOver";

const Content = () => {
  const screens = [
    {
      title: "General Setup",
      image: "https://www.anthemav.com/images/mrx_avm_mca/analytics1.jpg",
      bullets: [
        "Custom Name Your Device",
        "Configure User Preferences",
        "Adjust Display Settings",
        "Adjust CEC Settings",
        "Plus More",
      ],
    },
    {
      title: "Main Zone",
      image: "https://www.anthemav.com/images/mrx_avm_mca/analytics2.jpg",
      bullets: [
        "Toggle Power",
        "Adjust Volume",
        "Select Current Audio Mode",
        "On-The-Fly Level Adjustments",
        "Plus More",
      ],
    },
    {
      title: "Input Setup",
      image: "https://www.anthemav.com/images/mrx_avm_mca/analytics3.jpg",
      bullets: [
        "Add/Delete Inputs",
        "Customize Input Names",
        "Configure Input Settings",
        "Toggle ARC On/Off",
        "Plus More",
      ],
    },
    {
      title: "Network Setup",
      image: "https://www.anthemav.com/images/mrx_avm_mca/analytics4.jpg",
      bullets: [
        "Configure Network Settings",
        "Configure Trigger Settings",
        "Configure IR Settings",
        "Adjust Tx Status",
        "Plus More",
      ],
    },
    {
      title: "Store Load",
      image: "https://www.anthemav.com/images/mrx_avm_mca/analytics5.jpg",
      bullets: [
        "Store/Load Settings",
        "Import/Export Settings",
        "Reset On-The-Fly Adjustments",
        "Update Firmware",
      ],
    },
    {
      title: "Zone 2",
      image: "https://www.anthemav.com/images/mrx_avm_mca/analytics6.jpg",
      bullets: [
        " Zone 2 Volume",
        "Zone 2 Max Volume",
        "Power-On Volume",
        "Zone 2 Input",
        "Zone 2 Power-On Input",
        "Default Streaming Zone",
      ],
    },
  ];
  return (
    <div className="px-4 pt-5 pb-5 sm:px-0 sm:pt-0">
      <div className="space-y-8 px-4 sm:px-6 sm:space-y-6">
        <div className="mt-3  text-gray-900 sm:col-span-2">
          <p className="text-sm lg:text-md">
            The Anthem Web User Interface was specially designed for easy setup.
            Nothing could be more simple than on-site configuration and
            calibration using our intuitive web based controls. The specially
            designed, adaptive web based user interface works on any device.
            Custom configure everything the new AVM/MRX series has to offer.
          </p>
          {screens.map((screen) => (
            <div className="py-5 border-b-2 border-b-gray-200 text-gray-600">
              <h5 className="font-bold text-sm lg:text-md text-gray-900 mb-3">
                {screen.title}
              </h5>
              <div className="grid grid-cols-2">
                <div>
                  <img className="w-full" src={screen.image} />
                </div>
                <div>
                  <ul className="list-disc pl-5 pt-2 text-sm lg:text-md">
                    {screen.bullets?.map((bullet) => (
                      <li>{bullet}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const ComplexSimplicity = () => {
  const [showSlideOver, setSlideOver] = React.useState(false);

  const handleClick = () => {
    setSlideOver(true);
  };

  return (
    <>
      <SlideOver
        open={showSlideOver}
        setOpen={setSlideOver}
        content={<Content />}
        title={"Complexity Simplified"}
      />
      <section className="z-50 relative" id="complex_simplicity">
        <div
          className="bg-black py-12 md:py-20 px-5  bg-no-repeat bg-cover bg-bottom"
          style={{
            backgroundImage:
              "url(" +
              "https://cdn.pmlsound.com/anthem/avm90/images/complex-simplicity-made-easy-bg-only_.jpg" +
              ")",
          }}
        >
          <div className=" max-w-7xl mx-auto ">
            <h4 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center lg:text-left  text-white leading-snug ">
              Complexity Simplified
            </h4>
            <div className="lg:flex flex-row  gap-5">
              <div className="basis-5/12		">
                <p className="text-white mt-10 text-xl font-light  lg:text-left text-center mx-auto ">
                  At Anthem, our goal is to shape how you interact with your
                  technology, so we went the extra mile to ensure no detail is
                  overlooked while providing the utmost flexibility when it
                  comes to device setup. Using a phone, tablet or laptop, owners
                  can easily access any function or setting and make changes on
                  the fly. Power the primary or secondardy zone on and off,
                  adjust volume, change audio modes, tweak channel trims and
                  more, for a perfect surround sound experience. You're in
                  control, and it's never been easier.
                </p>
                <div className="mt-8 mx-auto invisible lg:visible h-0 lg:h-full ">
                  <Button name="Learn more" handleClick={handleClick} />
                </div>
              </div>
              <div className="w-full lg:w-3/5 basis-7/12 py-14 md:py-0">
                <video
                  id="video"
                  width="100%"
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="lg:absolute lg:w-fit lg:bottom-11 bottom-0 hidden md:block"
                >
                  <source
                    src="https://cdn.pmlsound.com/anthem/avm90/videos/avm90_complex_simplicity___.webm"
                    type="video/webm"
                  />
                  <source
                    src="https://cdn.pmlsound.com/anthem/avm90/videos/avm90_complex_simplicity___.mp4"
                    type="video/mp4"
                  />
                </video>
                <img
                  src="https://cdn.pmlsound.com/anthem/avm90/images/complex-simplicity-made-easy.png"
                  alt="web ui"
                  className="block md:hidden lg:hidden -mb-20"
                />
              </div>
            </div>
          </div>
          <div className=" mt-10 mx-auto visible lg:invisible h-full lg:h-0  ">
            <Button name="Learn more" handleClick={handleClick} />
          </div>
        </div>
      </section>
    </>
  );
};

export default ComplexSimplicity;
